import {
  UpdateMerchantBusinessPayload,
  UpdateMerchantSocialMediaPayload,
  updateMerchantAddressPayload,
  updateMerchantInfoPayload,
} from "@/models/payload/profile";
import { UpdateMerchantTemplateCommand, UpdateMerchantBusinessCommand } from "@/models/club";
import clubRequest from "../axios";

const getMerchant = async () => (await clubRequest.merchantList()).data;

const getMerchantForMerchantUser = async (mobileNumber: string) =>
  (
    await clubRequest.merchantUserGetByMobileNumberList({
      mobileNumber: mobileNumber,
    })
  ).data;

const getMerchantTypes = async () =>
  (await clubRequest.merchantTypeList()).data;

const updateMerchant = async (command: updateMerchantInfoPayload) =>
  (await clubRequest.merchantUpdate(command)).data;

const updateMerchantBusiness = async (command: UpdateMerchantBusinessPayload) =>
  (
    await clubRequest.merchantBusinessUpdate({
      ...command,
      merchantTypeId: Number(command.merchantTypeId),
      // The API takes the text value ("hairSalon"); the generated type says number.
      businessType: (command.businessType ?? undefined) as unknown as UpdateMerchantBusinessCommand["businessType"],
    })
  ).data;

const updateMerchantAddress = async (command: updateMerchantAddressPayload) =>
  (await clubRequest.merchantAddressUpdate(command)).data;

const updateMerchantSocialMedia = async (
  command: UpdateMerchantSocialMediaPayload
) => (await clubRequest.merchantSocialMediaUpdate(command)).data;

const updateMerchantProfileImage = async (image: File) =>
  (
    await clubRequest.merchantLogoUpdate({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      logo: image,
    })
  ).data;

// The share image: the server crops it to 1200×630 from the centre.
const updateMerchantCover = async (image: File) =>
  (
    await clubRequest.merchantCoverUpdate({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      cover: image,
    })
  ).data;

const updateMerchantTemplate = async (command: UpdateMerchantTemplateCommand) =>
  (await clubRequest.b2CMerchantTemplateUpdate(command)).data;

const merchantService = {
  getMerchant,
  updateMerchant,
  getMerchantTypes,
  updateMerchantBusiness,
  updateMerchantAddress,
  updateMerchantSocialMedia,
  updateMerchantProfileImage,
  updateMerchantCover,
  getMerchantForMerchantUser,
  updateMerchantTemplate,
};

export default merchantService;
